var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('btn',{staticClass:"overlay",attrs:{"text":"Professional Tax","type":"primary"},on:{"click":_vm.goToProfessionalTax}}),_c('under-construction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }